import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import Axios from 'axios';
import config from '../../config';
import { updateUserLocationDetails } from '../../Actions';
import browserDetect from '../../utils/browserDetect';
import { setFCUserProperties, destroyChat } from '../../utils/chat';
import { getParams } from '../../utils';
import firstVisited from '../../utils/firstVisited';
import { getCountryCode } from '../../utils/countryCode';
import statsCount from '../../Data/statsCount';
import Header from '../ui/Header';
import Banner from './Banner';
// import Courses from './Courses';
import Features from '../ui/Features';
import InterviewProblems from '../ui/Features/InterviewProblems';
import LearningPath from './LearningPath';
import Testimonials from '../ui/NewTestimonials';
import Footer from '../ui/Footer';
import InfoBar from './Info';
// import { SnackBarDiv, SpecialOffer } from '../ui/SnackBar';
// import ScheduleCourseCounselling from '../CourseCounselling/ScheduleCourseCounselling';
import HeaderSnackbar from '../Account/HeaderSnackbar';
import SignupInfo from '../ui/SignUpInfo';
import { SiteStats, CompanyLogos } from '../ui/SiteStats';
import SingleTestimonial from '../ui/SingleTestimonial';
import ProgrammingLanguages from '../ui/ProgrammingLanguages';
import FAQList from '../ui/FAQ';

class Home extends Component {
  state = {
    snackbar: false,
    headerSnackbar: false,
    offerSnackBar: localStorage.getItem('snackBarClosedDate') ? false : true,
    browser: '',
    infoStatus: false,
    yearEndOffer: false,
    priceDetails: {},
    countryCode: '',
    headerOfferSnackbar: false,
    headerOfferLink: '',
    headerOfferName: '',
    headerOfferPercent: '',
    headerOfferPath: '',
    headerOfferDayCount: 0,
    headerOfferImg: '',
    headerOfferTitle: '',
    headerOfferEndTime: '',
    scrolling: false,
    staticOfferSnackbar: false,
    offerApiLoading: true,
    primeOfferPrice: '',
  };

  async componentDidMount() {
    const { userID, email, history, userLocationDetails, updateUserLocationDetails } = this.props;

    firstVisited();
    if (userID !== null) {
      history.push('/dashboard');
    } else {
      let countryCode = await getCountryCode(userLocationDetails, updateUserLocationDetails);

      window.addEventListener('scroll', this.handleScroll);

      // let result = await Axios.get(config.apiURL + `/pricing?countryCode=${countryCode}`);
      this.setState({ countryCode: countryCode });

      // if (countryCode === 'IN') {
      //   setTimeout(() => {
      //     this.setState({
      //       staticOfferSnackbar: true,
      //     });
      //   }, 1000);
      // }

      // if (!localStorage.getItem('snackBarClosedDate') || (result.data.offerDetails && result.data.offerDetails.createdAt > localStorage.getItem('snackBarClosedDate'))) {
      //   this.setState({ offerSnackBar: true });
      // } else {
      //   this.setState({ offerSnackBar: false });
      // }
      // if (result) {
      //   this.setState({
      //     priceDetails: result.data,
      //     infoStatus: true,
      //   });
      // }

      // document.addEventListener('contextmenu', this.handleContextMenu);

      // header offer snackbar condition starts
      try {
        let offerResult = await Axios.get(config.logsDomain + `/lboff?country=${countryCode}&type=originals`),
          offerResultData;

        if (offerResult && offerResult.data && offerResult.data.length !== 0) {
          offerResultData = offerResult.data[0];
          let { offerName, offerPercent, offerPath, promoCode, dayCount, offerImgUrl, offerHeading, endTime, primeOfferPrice } = offerResultData;
          setTimeout(() => {
            this.setState({
              headerOfferSnackbar: true,
              headerOfferName: offerName,
              headerOfferPercent: offerPercent,
              headerOfferPath: offerPath,
              headerOfferLink: promoCode,
              headerOfferDayCount: dayCount,
              headerOfferEndTime: endTime,
              headerOfferImg: offerImgUrl,
              headerOfferTitle: offerHeading,
              primeOfferPrice: primeOfferPrice,
              offerApiLoading: false,
            });
          }, 1000);
        } else this.setState({ offerApiLoading: false });
      } catch (error) {
        this.setState({ offerApiLoading: false });
        console.log('offer error ', error);
      }
      // header offer snackbar condition ends

      // Initialise the chatbot
      const name = this.props.name.split(' ');
      const firstName = name[0];
      const lastName = name[1];
      window.fcWidget && setFCUserProperties(userID, firstName, lastName, email);

      let sBrowser = browserDetect();
      this.setState({ browser: sBrowser });

      // Show info bar
      // setTimeout(() => {
      //   this.setState({ infoStatus: false });
      // }, 1500);

      //get referrer url and store in local storage
      const url = window.location.search;
      const referrer_medium = getParams(url);
      let keyExist = referrer_medium.hasOwnProperty('refID');

      if (keyExist === true) {
        localStorage.setItem('ref_src', referrer_medium.refID);
      }

      url && localStorage.setItem('referrer_medium', JSON.stringify({ ...referrer_medium, medium: document.referrer }));
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    // Destroy the chatbot
    destroyChat();
  }

  // handleContextMenu = (event) => {
  //   event.preventDefault();
  // };

  handleSnackBarClose = () => {
    this.setState({ snackbar: false });
  };

  handleOfferSnackBarClose = () => {
    let todayDate = new Date().toISOString();
    localStorage.setItem('snackBarClosedDate', todayDate);
    this.setState({ offerSnackBar: false });
  };

  handleInfoBar = () => {
    this.setState({ infoStatus: false });
  };

  handleYearEndOffer = () => {
    this.setState({ yearEndOffer: false });
  };

  handleHeaderSnackbar = () => {
    this.setState({ headerSnackbar: false });
  };

  closeHeaderOfferSnackbar = () => {
    this.setState({ headerOfferSnackbar: false });
  };

  closeStaticOfferSnackbar = () => {
    this.setState({ staticOfferSnackbar: false });
  };

  handleScroll = () => {
    this.setState({ scrolling: true });
    let top = window.scrollY <= 0;
    if (top === true) this.setState({ scrolling: false });
  };

  render() {
    const { history, country, name } = this.props;
    const {
      browser,
      snackbar,
      infoStatus,
      priceDetails,
      offerSnackBar,
      countryCode,
      headerSnackbar,
      yearEndOffer,
      headerOfferSnackbar,
      headerOfferName,
      headerOfferPercent,
      headerOfferPath,
      headerOfferLink,
      headerOfferDayCount,
      headerOfferImg,
      headerOfferEndTime,
      headerOfferTitle,
      scrolling,
      staticOfferSnackbar,
      offerApiLoading,
      primeOfferPrice,
    } = this.state;
    const browserList = ['Microsoft Internet Explorer', 'Microsoft Edge', 'Apple Safari'];
    const browserSupport = browserList.includes(browser);
    const cloudFront = config.cloudFront;
    // let infoBarMessage = 'Super Summer Offer | Get unlimited access to all courses at just';
    let signupLink = `/signup/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=jff-main-btn`;

    return (
      <Fragment>
        <Helmet>
          <title>Log2Base2® - World's First Visual Learning Platform</title>
          <meta
            name="description"
            content={`Log2Base2 is a globally trusted, fully animated learning platform with ${statsCount.Users.integer}+ learners across ${statsCount.Countries.integer}+ countries. Learn coding from scratch with our step-by-step code walkthroughs.`}
          />
          {process.env.REACT_APP_STAGE === 'prod' ? <meta name="robots" content="index, follow" /> : <meta name="robots" content="noindex, nofollow" />}
          {process.env.REACT_APP_STAGE === 'prod' ? <meta name="googlebot" content="index" /> : <meta name="googlebot" content="noindex" />}
        </Helmet>
        {/*priceDetails.isOfferEnabled && priceDetails.offerDetails.showsnackBar ? (
          <SpecialOffer
            showSnakeBar={offerSnackBar}
            isFromHome={true}
            history={history}
            priceDetails={priceDetails}
            handleSnackBarClose={this.handleOfferSnackBarClose}
          ></SpecialOffer>
        ) : null*/}
        {headerSnackbar && <HeaderSnackbar handleHeaderSnackbar={this.handleHeaderSnackbar} />}
        {/*
        {countryCode === 'IN' && headerOfferLink === 'REPUBLIC' ? (
          <InfoBar type={'oneTimeOffer'} country={countryCode} headerOfferLink={headerOfferLink} />
        */}
        {headerOfferSnackbar && (
          <InfoBar
            type={'originalsTopBar'}
            country={countryCode}
            headerOfferLink={headerOfferLink}
            headerOfferName={headerOfferName}
            headerOfferPath={headerOfferPath}
            headerOfferPercent={headerOfferPercent}
            headerOfferDayCount={headerOfferDayCount}
            headerOfferEndTime={headerOfferEndTime}
            headerOfferImg={headerOfferImg}
            headerOfferTitle={headerOfferTitle}
            handleInfoBar={this.closeHeaderOfferSnackbar}
          />
        )}

        {staticOfferSnackbar ? <InfoBar type={'confettiHeader'} content="originals-prime" handleInfoBar={this.closeStaticOfferSnackbar} /> : null}

        <Header
          cloudFront={cloudFront}
          fixed={true}
          isScrolling={scrolling}
          headerSnackbar={headerSnackbar}
          handleSnackBarClose={this.handleSnackBarClose}
          headerOfferSnackbar={headerOfferSnackbar || staticOfferSnackbar}
          primeOfferPrice={primeOfferPrice}
          primeOfferPriceLoading={offerApiLoading}
          primeOfferLink={headerOfferLink}
        />
        <Banner signupLink={signupLink} cloudFront={cloudFront} history={history} browserSupport={browserSupport} />
        <SiteStats />
        <CompanyLogos cloudFront={cloudFront} />
        <SingleTestimonial cloudFront={cloudFront} />

        <section className="outer-section">
          <div className="inner-section">
            <ProgrammingLanguages noMarginBottom={true} packages />
          </div>
        </section>
        <Features
          cloudFront={cloudFront}
          browserSupport={browserSupport}
          cta1Name={'Start Visualizing'}
          cta2Name={'Explore now'}
          cta3Name={'Start Learning'}
          ctaLink={() => history.push('/signup')}
        />
        <InterviewProblems cloudFront={cloudFront} />
        <LearningPath />
        {/*<Courses cloudFront={cloudFront} history={history} />*/}
        {/*<ScheduleCourseCounselling history={history} cloudFront={cloudFront} countryCode={countryCode} />*/}
        <Testimonials />
        <FAQList />
        <SignupInfo cloudFront={cloudFront} />
        <Footer />
        {/* {countryCode!=='' && countryCode!=="IN" && <InfoBar type={'promoCode'} isOnlyForAbroad= {true} infoBarMessage = {infoBarMessage} country={country} history={history} handleInfoBar={this.handleInfoBar} handleAllAccessClick={() => history.push('/pricing')} />} */}
        {/*{yearEndOffer && <InfoBar type={'originalsBottomBar'} handleInfoBar={this.handleYearEndOffer} />}*/}
      </Fragment>
    );
  }
}

const mapStateToProps = ({ User }) => ({
  userID: User.username,
  name: User.name,
  email: User.email,
  userLocationDetails: User.locationDetails,
  country: User.locationDetails && User.locationDetails.country,
});

const mapDispatchToProps = (dispatch) => ({
  updateUserLocationDetails: (locationDetails) => dispatch(updateUserLocationDetails(locationDetails)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
